module.exports = __webpack_public_path__ + "img/australia2.2f0578cd639a9565d32d70840358a4a5.jpg";